module.exports = __webpack_public_path__ + "img/1497471118.f1f44dfd.jpg";